import * as React from 'react';

function GroceryIcon({ 'aria-hidden': ariaHidden = true, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      aria-hidden={ariaHidden}
      {...props}
    >
      <defs>
        <path
          id="5gjy1x58aa"
          d="M15 4.286v1.071c0 .592-.48 1.072-1.071 1.072H1.07C.48 6.429 0 5.949 0 5.357V4.286c0-.592.48-1.072 1.071-1.072H13.93c.591 0 1.071.48 1.071 1.072zm-3.407-1.607h-1.414m4.13 4.232c-.124.035-.252.053-.38.053H1.07c-.134.001-.267-.017-.396-.053h13.634zM6.236.123c-.11-.09-.25-.135-.392-.122-.142.013-.273.082-.364.192L3.407 2.679h1.414l1.5-1.8c.09-.112.13-.254.115-.396-.016-.142-.088-.271-.2-.36zm5.357 2.556L9.52.193c-.123-.148-.315-.218-.504-.186C8.828.04 8.67.17 8.604.35c-.066.18-.032.381.09.529l1.485 1.8h1.414zm2.732 4.232l-.804 5.635c-.112.8-.8 1.39-1.607 1.383H3.07c-.805.008-1.492-.58-1.607-1.377L.674 6.91h13.65zm-8.968 5.325L4.821 9.02c-.03-.191-.16-.351-.342-.42-.18-.07-.385-.037-.535.085-.15.122-.225.315-.194.507l.536 3.214c.042.262.27.454.535.45h.086c.143-.02.271-.099.356-.216.085-.117.119-.263.094-.405zm2.679-3.129c0-.296-.24-.536-.536-.536-.296 0-.536.24-.536.536v3.214c0 .296.24.536.536.536.296 0 .536-.24.536-.536V9.107zm3.214.086c.03-.192-.043-.385-.194-.507-.15-.122-.354-.155-.535-.086-.181.07-.312.23-.342.421l-.536 3.215c-.025.142.01.288.094.405.085.117.213.195.356.216h.086c.265.004.493-.188.535-.45l.536-3.214z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <g>
                <path
                  d="M0 0H20V20H0z"
                  transform="translate(-751 -174) translate(155 170) translate(588) translate(8 4)"
                />
                <g transform="translate(-751 -174) translate(155 170) translate(588) translate(8 4) translate(2.5 3.333)">
                  <mask id="v4m8ieveub" fill="#fff">
                    <use xlinkHref="#5gjy1x58aa" />
                  </mask>
                  <use fill="#000" fillRule="nonzero" xlinkHref="#5gjy1x58aa" />
                  <g fill={props.fill ? props.fill : '#FAA01B'} mask="url(#v4m8ieveub)">
                    <path d="M0 0H20V20H0z" transform="translate(-2.5 -3.333)" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default GroceryIcon;
